<template>
  <div>
    <div class="pictures-swiper-overlay"></div>
    <div class="pictures-swiper-navigation">
      <div class="pictures-swiper-prev">
        <svg viewBox="0 0 320 512">
          <path
            d="M-1.9 256l17-17L207 47l17-17L257.9 64 241 81 65.9 256 241 431l17 17L224 481.9l-17-17L15 273l-17-17z"
          />
        </svg>
      </div>
      <div class="pictures-swiper-next">
        <svg viewBox="0 0 320 512">
          <path
            d="M321.9 256l-17 17L113 465l-17 17L62.1 448l17-17 175-175L79 81l-17-17L96 30.1l17 17L305 239l17 17z"
          />
        </svg>
      </div>
    </div>
    <div class="pictures-swiper-close" @click="close">
      <svg viewBox="0 0 384 512">
        <path
          d="M345 137l17-17L328 86.1l-17 17-119 119L73 103l-17-17L22.1 120l17 17 119 119L39 375l-17 17L56 425.9l17-17 119-119L311 409l17 17L361.9 392l-17-17-119-119L345 137z"
        />
      </svg>
    </div>
    <swiper
      class="pictures-swiper"
      ref="swiper"
      :modules="[Virtual, Navigation]"
      :slides-per-view="1"
      :space-between="50"
      :navigation="{
        nextEl: '.pictures-swiper-next',
        prevEl: '.pictures-swiper-prev',
      }"
      :loop="true"
      virtual
      @swiper="onSwiper"
    >
      <swiper-slide
        v-for="(picture, index) in pictures"
        :key="index"
        :virtualIndex="index"
      >
        <div class="pictures-swiper-slide">
          <swiper-picture
            v-if="!picture.field_media_video_file"
            :picture="picture"
          />
          <swiper-video v-else :picture="picture" />
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import SwiperPicture from "@/components/SwiperPicture";
import SwiperVideo from "@/components/SwiperVideo";
import { Virtual, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";

import "swiper/css";
import "swiper/css/navigation";

export default {
  components: {
    SwiperPicture,
    SwiperVideo,
    Swiper,
    SwiperSlide,
  },
  props: {
    pictures: {
      type: Array,
      required: true,
    },
    currentPictureIndex: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      Virtual,
      Navigation,
      swiper: null,
    };
  },
  mounted() {
    this.slideTo();
  },
  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },
    slideTo() {
      this.swiper.slideTo(this.currentPictureIndex, 0, false);
    },
    close() {
      this.$emit("close");
    },
  },
  watch: {
    currentPictureIndex() {
      this.slideTo();
    },
  },
};
</script>

<style lang="scss">
.pictures-swiper-overlay {
  position: fixed;
  inset: 0;
  background: rgba(#000, 0.9);
}

.pictures-swiper {
  position: fixed;
  inset: 0;
  margin: 30px auto;
}

.pictures-swiper-slide {
  height: 100%;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 1260px) {
    padding: 30px;
  }

  img {
    max-width: 100%;
    max-height: 100%;
    @media (min-width: 1260px) {
      max-width: 1200px;
    }
  }
}

.pictures-swiper-close {
  position: fixed;
  top: 30px;
  right: 30px;
  cursor: pointer;
  z-index: 10;

  svg {
    width: 40px;
    fill: #eae335;
  }
}

.pictures-swiper-navigation {
  position: fixed;
  inset: 0;
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: none;
  z-index: 10;
}

.pictures-swiper-prev,
.pictures-swiper-next {
  cursor: pointer;
  pointer-events: all;

  svg {
    width: 40px;
    fill: #eae335;
  }
}
</style>
